<template>
	<div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        사용자 패턴
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">사용자 패턴</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              {{this.$route.params.id == 'add' ? '패턴 추가' : '패턴 수정'}}
            </div>
            <div class="mb7">
              <label class="switch switch-sm switch-text switch-info mb-0" title="Pattern Use">
                <input type="checkbox" class="switch-input" v-model="model.is_use" id="use" >
                <span class="switch-label" data-on="ON" data-off="OFF"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_active" v-b-tooltip.hover>상태</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Active" id="Active" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="category">분류</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.category" :options="codes.code_category"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ext">확장자</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.ext" :options="codes.code_ext"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="type">타입</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.type" :options="codes.code_type"></b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="code">코드</label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-input md=5 :state="model.type == '1' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" type="text" id="code" v-model="model.code"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="descript">설명</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <b-form-textarea :rows="3" v-model="model.description" id="descript"></b-form-textarea>
            </b-col>
          </b-row>
          <b-button class="mt-4 btn-add" size="sm" @click="save"> 저장 </b-button>
          <b-button class="mt-4" size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
          <b-button class="mt-4 float-right" size="sm" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <router-view></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>